import React, {useEffect, useState} from 'react';
import {Rest} from "../../util/rest";
import {toast} from "react-toastify";
import {withUser} from "../../context/UserContext";
import * as InputTypes from "../assessmentV2/inputTypes";
import {fetchGlossary, buildGlossaryIndex} from "../../util/glossary";
import { annotateGlossaryText } from "../../util/glossaryAnnotator";

const AssessmentQuestionV2 = (props) => {
    const [answers, setAnswers] = React.useState([]);
    const [glossary, setGlossary] = useState(null);
    const capitalizeWords = (value) => {
        let string = value.toLowerCase().split("_");
        string = string.map((word) => word[0].toUpperCase() + word.slice(1))
        string.push("V2");
        return string.join("");
    }
    const QuestionType=InputTypes[capitalizeWords(props.question.questionType)];
    const isTable = props.question?.questionType === 'TABLE';
    
    useEffect(() => {
        getAnswers();
        return function cleanup() {
            setAnswers([]);
        };
    }, [props.question.id]); // Reload answers when question changes

    // Load glossary when report type contains IPATH
    useEffect(() => {
        const rt = props?.question?.reportType || props?.question?.assessmentTemplateReportType || props?.question?.template?.reportType;
        const effectiveRt = props?.question?.template?.reportType || props?.reportType;
        const reportType = effectiveRt || rt;
        if (reportType && (reportType.includes('IPATH') || reportType.includes('IPATH_'))) {
            // Extract language from report type: "IPATH_ES" -> "ES", "IPATH_ENG" -> "EN", default to "ES"
            const language = reportType.includes('ENG') ? 'EN' : 'ES';
            // Use the actual report type for the API call
            const apiReportType = reportType.includes('IPATH_') ? reportType : 'IPATH';
            fetchGlossary(props.user, apiReportType, language)
                .then(terms => setGlossary(buildGlossaryIndex(terms)))
                .catch(() => setGlossary(null));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.user, props.reportType, props.question]);

     
    const getAnswers = () => {
        Rest.authFetch(props.user, "/rest/assessment/" + props.assessmentId + "/" + props.question.id + "/answers")
                .then(response => {
                    if(response) {
                        setAnswers(response);
                        handleNewAnswer(response);
                    }
                    else {
                        toast.error("Error loading Answers");
                    }
                });
    }
    const getLanguageFromReportType = () => {
        // Extract language from report type: "IPATH_ES" -> "ES", "IPATH_ENG" -> "EN", default to "ES"
        const rt = props?.question?.reportType || props?.question?.assessmentTemplateReportType || props?.question?.template?.reportType;
        const effectiveRt = props?.question?.template?.reportType || props?.reportType;
        const reportType = effectiveRt || rt;
        return reportType && (reportType.includes('ENG') || reportType.includes('IPATH_ENG')) ? 'EN' : 'ES';
    };

    const annotateWithGlossary = (text) => {
        const language = getLanguageFromReportType();
        return annotateGlossaryText(glossary, text, language);
    };
    const handleNewAnswer = (localAnswers) => {
        localAnswers.forEach((answer) => {
            answer.assessmentId = props.assessmentId;
            answer.questionId = props.question.id;
        })
        saveAnswer(localAnswers);
    }
    const saveAnswer = (answers) => {
        console.log("saveAnswer - answers", answers);
        Rest.authFetch(props.user, "/rest/assessment/" + props.assessmentId + "/" + props.question.id + "/answers", {
            method: "PUT",
            body: JSON.stringify(answers)
        })
                .then(response => {
                    if(response) {
                        setAnswers(response);
                        console.log("onAnswer - response", response);
                        if(props.onAnswer)
                            props.onAnswer(props.question, response);
                    }
                    else {
                        toast.error("Error saving Answer");
                    }
                });
    }

    return (
            <div className={"flex-fill question p-3 mb-3" + (!props.valid ? " question-error" : "") + (props.readOnly ? " read-only" : "")}>
                {props.error ?
                 <div className="question-error row">
                     <div className="col-md-12">
                         {props.error}
                     </div>
                 </div> : null
                }
                <div className="row">
                    <div className={"col-md-12"}>
                        <div className={"row"}>
                            <div className="col-md-12 align-items-center mb-4 font-weight-bold">
                                <span>{annotateWithGlossary(props.question.question)}{props.question.required && !isTable ? "*" : ""}</span>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className="col-md-12">
                                <QuestionType handleNewAnswer={handleNewAnswer}
                                              question={props.question}
                                              answers={answers}
                                              readOnly={props.readOnly}
                                              glossary={glossary}
                                              language={getLanguageFromReportType()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    );
}

export default withUser(AssessmentQuestionV2);